import { PointCloud, BlockModel, Mesh, MeshSet, DrillHoles, Raster } from "assets/images";
import { ReactComponent as Folder } from "assets/images/folder-24px.svg";
import { ReactComponent as View } from "assets/images/view.svg";

import { ReactComponent as file } from "assets/images/file.svg";
import { ReactComponent as rawbm } from "assets/images/rawbm.svg";
import { ReactComponent as rawdh } from "assets/images/rawdh.svg";
import { ReactComponent as rawhm } from "assets/images/rawhm.svg";
import { ReactComponent as rawmesh } from "assets/images/rawmesh.svg";
import { ReactComponent as rawpc } from "assets/images/rawpc.svg";

import { ReactComponent as idxdh } from "assets/images/idxdh.svg";
import { ReactComponent as idxmesh } from "assets/images/idxmesh.svg";
import { ReactComponent as idxortho } from "assets/images/idxortho.svg";
import { ReactComponent as idxpc } from "assets/images/idxpc.svg";

import { ReactComponent as voxsurf } from "assets/images/voxsurf.svg";
import { ReactComponent as voxgen } from "assets/images/voxgen.svg";
import { ReactComponent as voxmesh } from "assets/images/voxmesh.svg";
import { ReactComponent as voxbm } from "assets/images/voxbm.svg";
import { ReactComponent as ortho } from "assets/images/ortho.svg";

import { ReactComponent as unknown } from "assets/images/Unknown.svg";
import { ReactComponent as lambda } from "assets/images/lambda.svg";
import { ReactComponent as Export } from "assets/images/export.svg";
import { ReactComponent as Report } from "assets/images/report.svg";
import { ReactComponent as Process } from "assets/images/process.svg";

export const voxelfarm = {
    META_TYPE_SURFACE: 0,
    META_TYPE_ORTHOIMG: 1,
    META_TYPE_POINTCLOUD: 2,
    META_TYPE_INDEXED_MESH: 3,
    META_TYPE_VOXELS: 4,
    META_TYPE_DENSITY: 5,
    META_TYPE_BLOCKTREE: 6,
    META_TYPE_VECTOR: 7,
    META_TYPE_SURFACE_COMPOSITE: 8,
};

export const inputsType: any = {
    mesh: "com.voxelfarm.program.view.mesh",
    bm: "com.voxelfarm.program.view.blockmodel",
    mt: "com.voxelfarm.program.view.materialtracking",
    pc: "com.voxelfarm.program.view.pointcloud",
    dh: "com.voxelfarm.program.view.drillholes",
    geochem: "com.voxelfarm.program.view.geochem",
};

export const defaultViewProgram: any = {
    VOXSURF: "com.voxelfarm.program.view.terrain",
    VOXGEN: "com.voxelfarm.program.view.surface",
    VOXMESH: "com.voxelfarm.program.view.mesh",
    VOXBM: "com.voxelfarm.program.view.blockmodel",
    VOXMT: "com.voxelfarm.program.view.materialtracking",
    IDXDENSITY: "com.voxelfarm.program.view.density",
    IDXMESH: "com.voxelfarm.program.view.mesh",
    IDXPC: "com.voxelfarm.program.view.pointcloud",
    IDXDH: "com.voxelfarm.program.view.drillholes",
    IDXORTHO: "com.voxelfarm.program.view.planegenerator",
    ORTHOVOX: "com.voxelfarm.program.view.terrain",
    GEOCHEM: "com.voxelfarm.program.view.geochem",
    SURFCOMPOSITE: "com.voxelfarm.program.view.terrain_composite_layer",
    VOXOP: "com.voxelfarm.program.view.realtimeterrain",
};

export enum trucksType {
    truck = "com.voxelfarm.program.view.truck",
    excav = "com.voxelfarm.program.view.excav",
}

export const programsMap: any = {
    pointcloud: "com.voxelfarm.program.view.pointcloud",
    mesh: "com.voxelfarm.program.view.mesh",
    blockmodel: "com.voxelfarm.program.view.blockmodel",
    drillholes: "com.voxelfarm.program.view.drillholes",
    raster: "com.voxelfarm.program.view.planegenerator",
};

export const programTranslator: any = {
    RAWDENSITY: "pointcloud",
    IDXDENSITY: "pointcloud",
    IDXORTHO: "raster",
    WMSORTHO: "raster",
    RAWPC: "pointcloud",
    RAWDH: "pointcloud",
    RAWHM: "mesh",
    RAWBM: "blockmodel",
    RAWMESH: "mesh",
    IDXMESH: "mesh",
    IDXPC: "pointcloud",
    IDXDH: "drillholes",
    VOXSURF: "mesh",
    VOXBM: "blockmodel",
    VOXMESH: "meshSet",
    VOXMT: "blockmodel",
    VOXOP: "blockmodel",
    VOXGEN: "blockmodel",
    VOXPC: "blockmodel",
    ORTHOVOX: "mesh",
    SURFCOMPOSITE: "terrain_composite",
};

export const fileIcon: any = {
    RAW: "RAW",
    RAWDENSITY: "RAWDENSITY",
    RAWPC: "RAWPC",
    RAWDH: "RAWDH",
    RAWGEOCHEM: "RAWPC",
    GEOCHEM: "IDXDH",
    RAWHM: "RAWHM",
    RAWBM: "RAWBM",
    RAWMESH: "RAWMESH",
    IDXDENSITY: "IDXDENSITY",
    IDXMESH: "IDXMESH",
    IDXORTHO: "IDXORTHO",
    IDXPC: "IDXPC",
    IDXDH: "IDXDH",
    VOXSURF: "VOXSURF",
    VOXBM: "VOXBM",
    VOXMESH: "VOXMESH",
    VOXMT: "VOXMT",
    VOXOP: "VOXOP",
    VOXGEN: "VOXGEN",
    VOXPC: "VOXPC",
    ORTHO: "ORTHO",
    VIEW: "view",

    WMSORTHO: "raster",
    ORTHOVOX: "ORTHOVOX",

    REPORT: "report",
    EXPORT: "export",
    PROCESS: "process",
    UNITY: "file",
    PROGRAM: "program",
    PYTHON: "file",
    DIAGRAM: "file",
    NETASM: "file",
    FOLDER: "folder",
    PROJECT: "project",
    FILE: "file",

    SURFCOMPOSITE: "SURFCOMPOSITE",
};

export const icons: any = {
    blockmodel: BlockModel,
    mesh: Mesh,
    meshSet: MeshSet,
    pointcloud: PointCloud,
    file: file,
    folder: Folder,
    drillholes: DrillHoles,
    raster: Raster,
    view: View,
    program: lambda,
    export: Export,
    report: Report,
    process: Process,

    IDXDH: idxdh,
    IDXDENSITY: unknown,
    IDXMESH: idxmesh,
    IDXPC: idxpc,
    IDXORTHO: idxortho,

    RAW: file,
    RAWDENSITY: file,
    RAWBM: rawbm,
    RAWDH: rawdh,
    RAWHM: rawhm,
    RAWMESH: rawmesh,
    RAWPC: rawpc,
    VOXSURF: voxsurf,
    VOXBM: voxbm,
    VOXMESH: voxmesh,
    VOXMT: voxbm,
    VOXOP: voxsurf,
    VOXGEN: voxgen,
    VOXPC: voxbm,
    ORTHOVOX: voxsurf,
    ORTHO: ortho,
    SURFCOMPOSITE: voxsurf,
};

export const filterTypes: any = {
    mesh: { label: "3D Mesh", type: "IDXMESH" },
    meshSet: { label: "3D Mesh Set", type: "VOXMESH" },
    blockmodel: { label: "3D Block Model", type: "VOXBM" },
    drillholes: { label: "Derived Drill Holes", type: "IDXDH" },
    raster: { label: "Derived Raster", type: "IDXORTHO" },
};

export var optionsNames: any = {
    0: "ImageryPlane",
    1: "DrillHoleSettings",
    2: "AttributeQuery",
    3: "ColorLegend",
    4: "RasterImagery",
    5: "BlockModelLimits",
};

export enum optionsTypes {
    imageryPlane = 0,
    drillHoleSettings = 1,
    attributeFilter = 2,
    colorLegend = 3,
    rasterImagery = 4,
    blockModelLimits = 5,
}

export var filterNames: any = {
    0: "Data Type",
    1: "Alpha Order",
    2: "Date Added",
    3: "Model Workflow",
    4: "Custom",
};

export var filterModelWorkflow: any = [
    defaultViewProgram.IDXDH, //Drill Holes
    defaultViewProgram.IDXPC, //GIS data
    defaultViewProgram.IDXPC, //Points
    defaultViewProgram.IDXPC, //Polylines
    defaultViewProgram.IDXORTHO, //Rasters
    defaultViewProgram.IDXMESH, //Meshes
    defaultViewProgram.VOXBM, //Block Models
    defaultViewProgram.VOXMT, //Material Tracking
];

export const ColorLegendDataMethods = [
    { value: 0, label: "Defined Interval" },
    { value: 1, label: "Equal Interval" },
    { value: 2, label: "Quantile" },
    { value: 3, label: "Natural Breaks (Jenks)" },
];

export const attributesMap: any = {
    colorAttribute: "color_legend_attribute",
    colorAttributeIndex: "color_legend_attribute_index",
    colorRangeMin: "color_legend_range_min",
    colorRangeMax: "color_legend_range_max",
    colorRangeStep: "color_legend_range_step",
    colorRangeCount: "color_legend_range_count",
    colorGradientId: "color_legend_gradient",
    colorMode: "color_legend_mode",
    colorStaticR: "color_legend_static_r",
    colorStaticG: "color_legend_static_g",
    colorStaticB: "color_legend_static_b",
    dataDrivenMethod: "color_legend_data_driven_method",
    dataDrivenEqualMode: "color_legend_data_driven_equal_mode",
    reverseGradient: "color_legend_reverse_gradient",
    interpolateGradient: "color_legend_interpolate_gradient",
    minMaxDynamic: "color_legend_data_driven_equal_minmax_dynamic",
    minMaxData: "color_legend_data_driven_equal_minmax_data",
    attributeQueryMode: "attribute_query_mode",
    attributeQueryString: "attribute_query_string",
    attributeQueryBuilderValue: "attribute_query_builder",
};

export const allowedDefaultMultipleAttributes: any = [
    "colorGradientId",
    "dataDrivenMethod",
    "dataDrivenEqualMode",
    "reverseGradient",
    "interpolateGradient",
    "minMaxDynamic",
    "minMaxData",
];

export const reverseAttributesMap: any = {
    color_legend_attribute: { name: "colorAttribute", type: "string" },
    color_legend_attribute_index: { name: "colorAttributeIndex", type: "number" },
    color_legend_range_min: { name: "colorRangeMin", type: "number" },
    color_legend_range_max: { name: "colorRangeMax", type: "number" },
    color_legend_range_step: { name: "colorRangeStep", type: "number" },
    color_legend_range_count: { name: "colorRangeCount", type: "number" },
    color_legend_gradient: { name: "colorGradientId", type: "string" },
    color_legend_mode: { name: "colorMode", type: "number" },
    color_legend_static_r: { name: "colorStaticR", type: "number" },
    color_legend_static_g: { name: "colorStaticG", type: "number" },
    color_legend_static_b: { name: "colorStaticB", type: "number" },
    color_legend_data_driven_method: { name: "dataDrivenMethod", type: "number" },
    color_legend_data_driven_equal_mode: {
        name: "dataDrivenEqualMode",
        type: "number",
    },
    color_legend_reverse_gradient: { name: "reverseGradient", type: "boolean" },
    color_legend_interpolate_gradient: {
        name: "interpolateGradient",
        type: "boolean",
    },
    color_legend_data_driven_equal_minmax_dynamic: {
        name: "minMaxDynamic",
        type: "boolean",
    },
    color_legend_data_driven_equal_minmax_data: {
        name: "minMaxData",
        type: "boolean",
    },
    attribute_query_mode: { name: "attributeQueryMode", type: "number" },
    attribute_query_string: { name: "attributeQueryString", type: "string" },
    attribute_query_builder: {
        name: "attributeQueryBuilderValue",
        type: "string",
    },
};

export const ColorLegendDefault: any = {
    colorAttribute: "",
    colorAttributeIndex: 0,
    colorRangeMin: 0.0,
    colorRangeMax: 1.0,
    colorRangeStep: 0.001,
    colorRangeCount: 10,
    colorGradientId: "color",
    alphaColorGradientId: "color",
    colorMode: 1,
    colorStaticR: 128,
    colorStaticG: 128,
    colorStaticB: 128,
    dataDrivenMethod: 0,
    dataDrivenEqualMode: 0,
    reverseGradient: false,
    reverseAlphaGradient: false,
    interpolateGradient: false,
    minMaxDynamic: false,
    minMaxData: false,
    isAlpha: false,
};

export const LayerPropertiesOptions: any = {
    blockmodel: [
        optionsTypes.attributeFilter,
        optionsTypes.blockModelLimits,
        optionsTypes.colorLegend,
        optionsTypes.rasterImagery,
    ],
    mesh: [optionsTypes.colorLegend, optionsTypes.rasterImagery],
    meshSet: [optionsTypes.colorLegend, optionsTypes.rasterImagery],
    pointcloud: [optionsTypes.colorLegend, optionsTypes.rasterImagery],
    drillholes: [
        optionsTypes.drillHoleSettings,
        optionsTypes.attributeFilter,
        optionsTypes.colorLegend,
        optionsTypes.rasterImagery,
    ],
    raster: [optionsTypes.imageryPlane, optionsTypes.colorLegend, optionsTypes.rasterImagery],
    planegenerator: [optionsTypes.imageryPlane, optionsTypes.rasterImagery],
    terrain_composite: [optionsTypes.colorLegend, optionsTypes.rasterImagery],
};

export type MeshProperty = {
    parentLayer: string;
    meshIndex: number;
    meshVisible: boolean;
    meshOpacity: number;
    meshUseParentColorLegend: boolean;
    meshStaticColorFront: any;
    meshStaticColorBack: any;
};

export const defaultGradients: any = {
    cyclic_protanopic_deuteranopic_bwyk_16_96_c31_n256: [
        { position: 0, r: 62, g: 135, b: 234 },
        { position: 0.125, r: 165, g: 186, b: 242 },
        { position: 0.25, r: 235, g: 234, b: 233 },
        { position: 0.5, r: 154, g: 132, b: 18 },
        { position: 0.75, r: 47, g: 46, b: 48 },
        { position: 1, r: 60, g: 133, b: 232 },
    ],
    cyclic_protanopic_deuteranopic_wywb_55_96_c33_n256: [
        { position: 0, r: 238, g: 237, b: 236 },
        { position: 0.25, r: 163, g: 139, b: 2 },
        { position: 0.5, r: 235, g: 234, b: 235 },
        { position: 0.625, r: 160, g: 185, b: 247 },
        { position: 0.75, r: 55, g: 140, b: 248 },
        { position: 0.875, r: 166, g: 188, b: 247 },
        { position: 1, r: 237, g: 237, b: 238 },
    ],
    cyclic_tritanopic_cwrk_40_100_c20_n256: [
        { position: 0, r: 38, g: 187, b: 215 },
        { position: 0.125, r: 163, g: 221, b: 236 },
        { position: 0.25, r: 249, g: 248, b: 248 },
        { position: 0.5, r: 233, g: 148, b: 136 },
        { position: 0.75, r: 99, g: 100, b: 101 },
        { position: 1, r: 36, g: 186, b: 214 },
    ],
    cyclic_tritanopic_wrwc_70_100_c20_n256: [
        { position: 0, r: 251, g: 250, b: 250 },
        { position: 0.25, r: 243, g: 154, b: 142 },
        { position: 0.5, r: 248, g: 249, b: 249 },
        { position: 0.75, r: 45, g: 194, b: 222 },
        { position: 0.875, r: 168, g: 224, b: 238 },
        { position: 1, r: 250, g: 251, b: 251 },
    ],
    diverging_isoluminant_cjm_75_c23_n256: [
        { position: 0, r: 0, g: 201, b: 255 },
        { position: 0.125, r: 93, g: 197, b: 238 },
        { position: 0.25, r: 134, g: 193, b: 220 },
        { position: 0.5, r: 184, g: 184, b: 187 },
        { position: 0.75, r: 212, g: 173, b: 206 },
        { position: 1, r: 237, g: 158, b: 228 },
    ],
    diverging_isoluminant_cjo_70_c25_n256: [
        { position: 0, r: 0, g: 182, b: 255 },
        { position: 0.125, r: 92, g: 179, b: 236 },
        { position: 0.25, r: 128, g: 177, b: 214 },
        { position: 0.75, r: 213, g: 159, b: 140 },
        { position: 1, r: 246, g: 144, b: 109 },
    ],
    diverging_linear_bjr_30_55_c53_n256: [
        { position: 0, r: 0, g: 42, b: 215 },
        { position: 0.125, r: 62, g: 58, b: 186 },
        { position: 0.25, r: 86, g: 73, b: 157 },
        { position: 0.5, r: 101, g: 100, b: 100 },
        { position: 0.75, r: 188, g: 84, b: 59 },
        { position: 0.875, r: 225, g: 66, b: 35 },
        { position: 1, r: 255, g: 25, b: 0 },
    ],
    diverging_linear_bjy_30_90_c45_n256: [
        { position: 0, r: 20, g: 49, b: 193 },
        { position: 0.25, r: 109, g: 96, b: 170 },
        { position: 0.5, r: 145, g: 145, b: 144 },
        { position: 0.75, r: 203, g: 185, b: 101 },
        { position: 1, r: 253, g: 228, b: 9 },
    ],
    diverging_protanopic_deuteranopic_bwy_60_95_c32_n256: [
        { position: 0, r: 58, g: 144, b: 254 },
        { position: 0.25, r: 169, g: 190, b: 249 },
        { position: 0.5, r: 237, g: 237, b: 236 },
        { position: 1, r: 168, g: 144, b: 8 },
    ],
    diverging_rainbow_bgymr_45_85_c67_n256: [
        { position: 0, r: 8, g: 92, b: 248 },
        { position: 0.125, r: 49, g: 147, b: 121 },
        { position: 0.1875, r: 63, g: 164, b: 49 },
        { position: 0.25, r: 103, g: 175, b: 29 },
        { position: 0.375, r: 178, g: 193, b: 22 },
        { position: 0.5, r: 244, g: 204, b: 31 },
        { position: 0.625, r: 254, g: 160, b: 108 },
        { position: 0.75, r: 252, g: 106, b: 156 },
        { position: 0.8125, r: 248, g: 74, b: 165 },
        { position: 0.875, r: 241, g: 54, b: 116 },
        { position: 1, r: 215, g: 5, b: 0 },
    ],
    diverging_tritanopic_cwr_75_98_c20_n256: [
        { position: 0, r: 41, g: 202, b: 231 },
        { position: 0.25, r: 169, g: 226, b: 240 },
        { position: 0.5, r: 247, g: 247, b: 247 },
        { position: 1, r: 253, g: 160, b: 148 },
    ],
    diverging_bkr_55_10_c35_n256: [
        { position: 0, r: 25, g: 129, b: 250 },
        { position: 0.25, r: 49, g: 75, b: 130 },
        { position: 0.5, r: 34, g: 31, b: 33 },
        { position: 1, r: 230, g: 80, b: 65 },
    ],
    diverging_bky_60_10_c30_n256: [
        { position: 0, r: 14, g: 148, b: 250 },
        { position: 0.25, r: 48, g: 84, b: 130 },
        { position: 0.5, r: 33, g: 32, b: 32 },
        { position: 1, r: 179, g: 139, b: 26 },
    ],
    diverging_bwg_20_95_c41_n256: [
        { position: 0, r: 17, g: 45, b: 104 },
        { position: 0.125, r: 46, g: 88, b: 172 },
        { position: 0.25, r: 51, g: 141, b: 229 },
        { position: 0.3125, r: 66, g: 169, b: 245 },
        { position: 0.375, r: 120, g: 195, b: 251 },
        { position: 0.4375, r: 183, g: 218, b: 248 },
        { position: 0.5, r: 223, g: 235, b: 236 },
        { position: 0.625, r: 105, g: 204, b: 174 },
        { position: 0.6875, r: 54, g: 181, b: 136 },
        { position: 0.75, r: 36, g: 155, b: 93 },
        { position: 0.875, r: 21, g: 104, b: 32 },
        { position: 1, r: 0, g: 58, b: 2 },
    ],
    diverging_bwr_20_95_c54_n256: [
        { position: 0, r: 23, g: 41, b: 114 },
        { position: 0.125, r: 41, g: 78, b: 207 },
        { position: 0.25, r: 119, g: 126, b: 244 },
        { position: 0.375, r: 185, g: 180, b: 250 },
        { position: 0.5, r: 239, g: 227, b: 231 },
        { position: 0.625, r: 253, g: 163, b: 144 },
        { position: 0.75, r: 231, g: 89, b: 68 },
        { position: 0.875, r: 182, g: 5, b: 15 },
        { position: 1, r: 102, g: 7, b: 2 },
    ],
    diverging_bwr_40_95_c42_n256: [
        { position: 0, r: 33, g: 81, b: 219 },
        { position: 0.25, r: 160, g: 156, b: 232 },
        { position: 0.5, r: 238, g: 231, b: 233 },
        { position: 0.75, r: 231, g: 139, b: 117 },
        { position: 1, r: 192, g: 2, b: 6 },
    ],
    diverging_bwr_55_98_c37_n256: [
        { position: 0, r: 36, g: 128, b: 255 },
        { position: 0.25, r: 170, g: 186, b: 253 },
        { position: 0.5, r: 249, g: 246, b: 247 },
        { position: 0.75, r: 251, g: 166, b: 146 },
        { position: 1, r: 230, g: 80, b: 55 },
    ],
    diverging_cwm_80_100_c22_n256: [
        { position: 0, r: 0, g: 217, b: 255 },
        { position: 0.0625, r: 82, g: 222, b: 255 },
        { position: 0.125, r: 120, g: 227, b: 255 },
        { position: 0.375, r: 216, g: 246, b: 255 },
        { position: 0.5, r: 255, g: 255, b: 255 },
        { position: 0.625, r: 255, g: 234, b: 251 },
        { position: 0.875, r: 252, g: 194, b: 244 },
        { position: 1, r: 250, g: 174, b: 240 },
    ],
    diverging_gwr_55_95_c38_n256: [
        { position: 0, r: 57, g: 151, b: 14 },
        { position: 0.25, r: 155, g: 196, b: 133 },
        { position: 0.5, r: 238, g: 234, b: 230 },
        { position: 0.75, r: 250, g: 160, b: 149 },
        { position: 1, r: 237, g: 71, b: 68 },
    ],
    diverging_gwv_55_95_c39_n256: [
        { position: 0, r: 57, g: 151, b: 14 },
        { position: 0.25, r: 155, g: 196, b: 133 },
        { position: 0.5, r: 236, g: 235, b: 235 },
        { position: 1, r: 184, g: 89, b: 228 },
    ],
    color: [
        { position: 0, r: 0, g: 84, b: 179 },
        { position: 0.25, r: 46, g: 119, b: 178 },
        { position: 0.5, r: 178, g: 178, b: 178 },
        { position: 0.75, r: 178, g: 106, b: 83 },
        { position: 1, r: 178, g: 1, b: 54 },
    ],
    dirt: [
        { position: 0, r: 78, g: 80, b: 82 },
        { position: 0.046875, r: 93, g: 96, b: 97 },
        { position: 0.05078125, r: 94, g: 98, b: 96 },
        { position: 0.0546875, r: 63, g: 67, b: 66 },
        { position: 0.0625, r: 96, g: 102, b: 95 },
        { position: 0.06640625, r: 92, g: 96, b: 91 },
        { position: 0.0703125, r: 73, g: 75, b: 73 },
        { position: 0.078125, r: 117, g: 124, b: 117 },
        { position: 0.08203125, r: 109, g: 114, b: 109 },
        { position: 0.0859375, r: 131, g: 138, b: 131 },
        { position: 0.109375, r: 112, g: 115, b: 112 },
        { position: 0.1132813, r: 107, g: 112, b: 107 },
        { position: 0.1210938, r: 78, g: 80, b: 78 },
        { position: 0.1289063, r: 111, g: 113, b: 111 },
        { position: 0.140625, r: 104, g: 109, b: 111 },
        { position: 0.1484375, r: 83, g: 89, b: 88 },
        { position: 0.1523438, r: 80, g: 87, b: 89 },
        { position: 0.15625, r: 107, g: 113, b: 113 },
        { position: 0.1640625, r: 91, g: 95, b: 90 },
        { position: 0.171875, r: 127, g: 134, b: 126 },
        { position: 0.1796875, r: 142, g: 145, b: 137 },
        { position: 0.234375, r: 139, g: 141, b: 126 },
        { position: 0.2460938, r: 162, g: 165, b: 147 },
        { position: 0.2578125, r: 146, g: 150, b: 135 },
        { position: 0.2734375, r: 153, g: 156, b: 139 },
        { position: 0.2890625, r: 130, g: 135, b: 118 },
        { position: 0.296875, r: 148, g: 150, b: 132 },
        { position: 0.3203125, r: 132, g: 134, b: 116 },
        { position: 0.3359375, r: 134, g: 138, b: 124 },
        { position: 0.3398438, r: 89, g: 94, b: 86 },
        { position: 0.34375, r: 75, g: 80, b: 74 },
        { position: 0.3476563, r: 102, g: 108, b: 102 },
        { position: 0.3515625, r: 112, g: 117, b: 112 },
        { position: 0.3554688, r: 100, g: 107, b: 100 },
        { position: 0.3632813, r: 105, g: 111, b: 105 },
        { position: 0.3710938, r: 84, g: 84, b: 78 },
        { position: 0.3789063, r: 116, g: 117, b: 107 },
        { position: 0.3828125, r: 103, g: 106, b: 98 },
        { position: 0.390625, r: 57, g: 58, b: 58 },
        { position: 0.3984375, r: 83, g: 85, b: 83 },
        { position: 0.4023438, r: 97, g: 99, b: 97 },
        { position: 0.40625, r: 94, g: 97, b: 94 },
        { position: 0.4179688, r: 62, g: 63, b: 61 },
        { position: 0.421875, r: 82, g: 85, b: 79 },
        { position: 0.4296875, r: 116, g: 121, b: 114 },
        { position: 0.4335938, r: 126, g: 129, b: 120 },
        { position: 0.4453125, r: 104, g: 110, b: 106 },
        { position: 0.453125, r: 127, g: 132, b: 119 },
        { position: 0.4609375, r: 134, g: 139, b: 124 },
        { position: 0.484375, r: 98, g: 103, b: 96 },
        { position: 0.4921875, r: 128, g: 130, b: 118 },
        { position: 0.5039063, r: 129, g: 132, b: 116 },
        { position: 0.5117188, r: 102, g: 105, b: 92 },
        { position: 0.53125, r: 124, g: 130, b: 105 },
        { position: 0.5390625, r: 120, g: 122, b: 102 },
        { position: 0.5625, r: 145, g: 139, b: 111 },
        { position: 0.5703125, r: 137, g: 123, b: 88 },
        { position: 0.609375, r: 159, g: 139, b: 93 },
        { position: 0.6132813, r: 148, g: 131, b: 84 },
        { position: 0.6210938, r: 172, g: 160, b: 116 },
        { position: 0.625, r: 174, g: 161, b: 117 },
        { position: 0.6289063, r: 162, g: 144, b: 97 },
        { position: 0.6484375, r: 177, g: 159, b: 112 },
        { position: 0.6640625, r: 169, g: 150, b: 103 },
        { position: 0.671875, r: 174, g: 156, b: 109 },
        { position: 0.6796875, r: 151, g: 133, b: 84 },
        { position: 0.6875, r: 146, g: 128, b: 84 },
        { position: 0.703125, r: 162, g: 144, b: 96 },
        { position: 0.7109375, r: 168, g: 151, b: 102 },
        { position: 0.7148438, r: 148, g: 131, b: 82 },
        { position: 0.734375, r: 173, g: 157, b: 107 },
        { position: 0.75, r: 171, g: 154, b: 105 },
        { position: 0.765625, r: 133, g: 107, b: 67 },
        { position: 0.7734375, r: 144, g: 119, b: 81 },
        { position: 0.7773438, r: 137, g: 110, b: 73 },
        { position: 0.78125, r: 140, g: 119, b: 81 },
        { position: 0.7890625, r: 158, g: 141, b: 100 },
        { position: 0.7929688, r: 172, g: 156, b: 114 },
        { position: 0.8046875, r: 146, g: 137, b: 95 },
        { position: 0.8164063, r: 164, g: 145, b: 102 },
        { position: 0.8203125, r: 151, g: 131, b: 89 },
        { position: 0.8242188, r: 151, g: 132, b: 92 },
        { position: 0.828125, r: 168, g: 147, b: 108 },
        { position: 0.8359375, r: 131, g: 120, b: 88 },
        { position: 0.8515625, r: 151, g: 149, b: 119 },
        { position: 0.8671875, r: 141, g: 132, b: 99 },
        { position: 0.8710938, r: 166, g: 149, b: 106 },
        { position: 0.875, r: 160, g: 148, b: 105 },
        { position: 0.8789063, r: 114, g: 112, b: 83 },
        { position: 0.8828125, r: 120, g: 117, b: 91 },
        { position: 0.890625, r: 135, g: 135, b: 110 },
        { position: 0.8984375, r: 146, g: 140, b: 108 },
        { position: 0.9140625, r: 136, g: 129, b: 99 },
        { position: 0.921875, r: 160, g: 158, b: 131 },
        { position: 0.9257813, r: 166, g: 163, b: 139 },
        { position: 0.9335938, r: 139, g: 142, b: 114 },
        { position: 0.9609375, r: 155, g: 158, b: 122 },
        { position: 0.9648438, r: 137, g: 139, b: 110 },
        { position: 0.96875, r: 146, g: 144, b: 115 },
        { position: 0.9726563, r: 179, g: 171, b: 135 },
        { position: 0.9765625, r: 181, g: 169, b: 131 },
        { position: 0.9921875, r: 170, g: 154, b: 111 },
        { position: 1, r: 184, g: 166, b: 124 },
    ],
    difference: [
        { position: 0, r: 224, g: 29, b: 51 },
        { position: 0.25, r: 191, g: 126, b: 133 },
        { position: 0.375, r: 176, g: 170, b: 171 },
        { position: 0.625, r: 169, g: 175, b: 170 },
        { position: 0.875, r: 47, g: 188, b: 86 },
        { position: 1, r: 1, g: 192, b: 55 },
    ],
    isoluminant_cgo_70_c39_n256: [
        { position: 0, r: 55, g: 183, b: 236 },
        { position: 0.5, r: 135, g: 184, b: 118 },
        { position: 0.75, r: 199, g: 168, b: 93 },
        { position: 1, r: 246, g: 144, b: 109 },
    ],
    isoluminant_cgo_80_c38_n256: [
        { position: 0, r: 112, g: 209, b: 255 },
        { position: 0.25, r: 121, g: 214, b: 206 },
        { position: 0.5, r: 156, g: 213, b: 148 },
        { position: 0.75, r: 217, g: 198, b: 119 },
        { position: 1, r: 255, g: 178, b: 129 },
    ],
    isoluminant_cm_70_c39_n256: [
        { position: 0, r: 20, g: 186, b: 230 },
        { position: 0.25, r: 121, g: 175, b: 236 },
        { position: 0.5, r: 179, g: 161, b: 229 },
        { position: 1, r: 254, g: 133, b: 173 },
    ],
    letter_e_48: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 0, g: 0, b: 0 },
    ],
    letter_n_48: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 0, g: 0, b: 0 },
    ],
    letter_z_48: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 0, g: 0, b: 0 },
    ],
    linear_protanopic_deuteranopic_kbjyw_5_95_c25_n256: [
        { position: 0, r: 17, g: 17, b: 17 },
        { position: 0.25, r: 1, g: 65, b: 126 },
        { position: 0.375, r: 67, g: 91, b: 141 },
        { position: 0.625, r: 165, g: 148, b: 92 },
        { position: 0.75, r: 199, g: 177, b: 105 },
        { position: 1, r: 241, g: 241, b: 241 },
    ],
    linear_protanopic_deuteranopic_kbw_5_98_c40_n256: [
        { position: 0, r: 17, g: 17, b: 17 },
        { position: 0.5, r: 1, g: 123, b: 229 },
        { position: 0.5625, r: 59, g: 138, b: 242 },
        { position: 0.625, r: 131, g: 153, b: 208 },
        { position: 0.75, r: 206, g: 184, b: 109 },
        { position: 0.8125, r: 231, g: 199, b: 53 },
        { position: 0.84375, r: 241, g: 207, b: 34 },
        { position: 0.875, r: 249, g: 216, b: 62 },
        { position: 1, r: 252, g: 249, b: 243 },
    ],
    linear_tritanopic_krjcw_5_95_c24_n256: [
        { position: 0, r: 17, g: 17, b: 17 },
        { position: 0.25, r: 115, g: 40, b: 35 },
        { position: 0.375, r: 131, g: 77, b: 70 },
        { position: 0.5, r: 119, g: 119, b: 121 },
        { position: 0.625, r: 75, g: 160, b: 179 },
        { position: 0.6875, r: 23, g: 179, b: 206 },
        { position: 0.71875, r: 9, g: 187, b: 216 },
        { position: 0.75, r: 33, g: 195, b: 224 },
        { position: 0.8125, r: 88, g: 209, b: 235 },
        { position: 0.9375, r: 193, g: 232, b: 243 },
        { position: 1, r: 241, g: 241, b: 241 },
    ],
    linear_tritanopic_krjcw_5_98_c46_n256: [
        { position: 0, r: 17, g: 17, b: 17 },
        { position: 0.25, r: 139, g: 2, b: 20 },
        { position: 0.5, r: 242, g: 28, b: 47 },
        { position: 0.5625, r: 251, g: 71, b: 69 },
        { position: 0.625, r: 229, g: 123, b: 116 },
        { position: 0.6875, r: 185, g: 164, b: 169 },
        { position: 0.75, r: 105, g: 197, b: 222 },
        { position: 0.78125, r: 49, g: 210, b: 242 },
        { position: 0.8125, r: 47, g: 219, b: 251 },
        { position: 0.9375, r: 200, g: 241, b: 251 },
        { position: 1, r: 249, g: 249, b: 249 },
    ],
    linear_bgyw_20_98_c66_n256: [
        { position: 0, r: 5, g: 0, b: 172 },
        { position: 0.125, r: 14, g: 55, b: 180 },
        { position: 0.25, r: 6, g: 94, b: 174 },
        { position: 0.5, r: 65, g: 162, b: 55 },
        { position: 0.625, r: 123, g: 186, b: 11 },
        { position: 0.75, r: 191, g: 204, b: 10 },
        { position: 0.875, r: 241, g: 226, b: 52 },
        { position: 0.9375, r: 252, g: 240, b: 109 },
        { position: 1, r: 249, g: 249, b: 249 },
    ],
    linear_blue_95_50_c20_n256: [
        { position: 0, r: 241, g: 241, b: 241 },
        { position: 1, r: 59, g: 124, b: 178 },
    ],
    linear_bmw_5_95_c86_n256: [
        { position: 0, r: 0, g: 2, b: 75 },
        { position: 0.25, r: 22, g: 15, b: 213 },
        { position: 0.375, r: 102, g: 28, b: 251 },
        { position: 0.5, r: 187, g: 28, b: 254 },
        { position: 0.625, r: 240, g: 67, b: 254 },
        { position: 0.75, r: 254, g: 133, b: 253 },
        { position: 1, r: 254, g: 235, b: 254 },
    ],
    linear_bmy_10_95_c71_n256: [
        { position: 0, r: 0, g: 15, b: 93 },
        { position: 0.125, r: 46, g: 26, b: 138 },
        { position: 0.25, r: 125, g: 17, b: 145 },
        { position: 0.375, r: 187, g: 12, b: 133 },
        { position: 0.5, r: 232, g: 51, b: 113 },
        { position: 0.75, r: 251, g: 162, b: 61 },
        { position: 1, r: 245, g: 249, b: 78 },
    ],
    linear_gow_60_85_c27_n256: [
        { position: 0, r: 102, g: 155, b: 144 },
        { position: 0.5, r: 212, g: 172, b: 106 },
        { position: 0.75, r: 216, g: 193, b: 144 },
        { position: 1, r: 212, g: 212, b: 212 },
    ],
    linear_gow_65_90_c35_n256: [
        { position: 0, r: 112, g: 173, b: 92 },
        { position: 0.5, r: 230, g: 184, b: 109 },
        { position: 1, r: 226, g: 226, b: 226 },
    ],
    linear_grey_0_100_c0_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 0.5, r: 119, g: 119, b: 119 },
        { position: 1, r: 255, g: 255, b: 255 },
    ],
    linear_grey_10_95_c0_n256: [
        { position: 0, r: 27, g: 27, b: 27 },
        { position: 0.5, r: 126, g: 126, b: 126 },
        { position: 1, r: 241, g: 241, b: 241 },
    ],
    linear_kbc_5_95_c73_n256: [
        { position: 0, r: 0, g: 1, b: 78 },
        { position: 0.25, r: 12, g: 17, b: 214 },
        { position: 0.375, r: 44, g: 59, b: 250 },
        { position: 0.5, r: 45, g: 109, b: 253 },
        { position: 0.75, r: 43, g: 191, b: 252 },
        { position: 0.8125, r: 42, g: 211, b: 251 },
        { position: 0.875, r: 77, g: 229, b: 249 },
        { position: 1, r: 179, g: 255, b: 246 },
    ],
    linear_kbgyw_10_98_c63_n256: [
        { position: 0, r: 27, g: 27, b: 27 },
        { position: 0.0625, r: 41, g: 25, b: 95 },
        { position: 0.125, r: 32, g: 27, b: 149 },
        { position: 0.1875, r: 11, g: 41, b: 179 },
        { position: 0.25, r: 7, g: 64, b: 184 },
        { position: 0.375, r: 18, g: 108, b: 159 },
        { position: 0.5, r: 50, g: 147, b: 85 },
        { position: 0.625, r: 98, g: 177, b: 27 },
        { position: 0.75, r: 175, g: 200, b: 4 },
        { position: 0.875, r: 236, g: 223, b: 45 },
        { position: 0.9375, r: 250, g: 238, b: 98 },
        { position: 1, r: 249, g: 249, b: 249 },
    ],
    linear_kgy_5_95_c69_n256: [
        { position: 0, r: 1, g: 21, b: 6 },
        { position: 0.5, r: 31, g: 138, b: 11 },
        { position: 0.75, r: 48, g: 206, b: 19 },
        { position: 0.875, r: 87, g: 240, b: 22 },
        { position: 1, r: 216, g: 255, b: 21 },
    ],
    linear_kryw_0_100_c71_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 0.5, r: 237, g: 21, b: 0 },
        { position: 0.625, r: 255, g: 105, b: 0 },
        { position: 0.875, r: 255, g: 219, b: 10 },
        { position: 0.9375, r: 255, g: 243, b: 36 },
        { position: 1, r: 255, g: 255, b: 255 },
    ],
    linear_kry_0_97_c73_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 0.5, r: 231, g: 16, b: 0 },
        { position: 0.625, r: 251, g: 98, b: 0 },
        { position: 0.75, r: 254, g: 158, b: 0 },
        { position: 1, r: 255, g: 255, b: 0 },
    ],
    linear_ternary_blue_0_44_c57_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 26, g: 84, b: 255 },
    ],
    linear_ternary_green_0_46_c42_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 0, g: 128, b: 0 },
    ],
    linear_ternary_red_0_50_c52_n256: [
        { position: 0, r: 0, g: 0, b: 0 },
        { position: 1, r: 230, g: 43, b: 0 },
    ],
    linear_wcmr_100_45_c42_n256: [
        { position: 0, r: 255, g: 255, b: 255 },
        { position: 0.25, r: 190, g: 218, b: 255 },
        { position: 0.375, r: 185, g: 193, b: 252 },
        { position: 0.5, r: 200, g: 162, b: 235 },
        { position: 0.75, r: 235, g: 87, b: 151 },
        { position: 0.875, r: 231, g: 49, b: 88 },
        { position: 1, r: 208, g: 33, b: 14 },
    ],
    linear_worb_100_25_c53_n256: [
        { position: 0, r: 255, g: 255, b: 255 },
        { position: 0.125, r: 243, g: 228, b: 175 },
        { position: 0.25, r: 244, g: 193, b: 131 },
        { position: 0.5, r: 239, g: 111, b: 105 },
        { position: 0.75, r: 188, g: 34, b: 135 },
        { position: 0.875, r: 131, g: 29, b: 155 },
        { position: 0.9375, r: 89, g: 36, b: 162 },
        { position: 1, r: 0, g: 42, b: 168 },
    ],
    linear_wyor_100_45_c55_n256: [
        { position: 0, r: 255, g: 255, b: 255 },
        { position: 0.125, r: 238, g: 239, b: 182 },
        { position: 0.25, r: 231, g: 217, b: 136 },
        { position: 0.75, r: 223, g: 108, b: 28 },
        { position: 1, r: 213, g: 15, b: 29 },
    ],
    rainbow_bgyrm_35_85_c69_n256: [
        { position: 0, r: 0, g: 48, b: 245 },
        { position: 0.125, r: 39, g: 122, b: 139 },
        { position: 0.25, r: 71, g: 163, b: 37 },
        { position: 0.375, r: 161, g: 188, b: 24 },
        { position: 0.5, r: 241, g: 202, b: 36 },
        { position: 0.75, r: 241, g: 103, b: 21 },
        { position: 0.8125, r: 242, g: 86, b: 51 },
        { position: 0.875, r: 252, g: 103, b: 115 },
        { position: 1, r: 253, g: 146, b: 250 },
    ],
    rainbow_bgyr_10_90_c83_n256: [
        { position: 0, r: 4, g: 0, b: 108 },
        { position: 0.125, r: 11, g: 24, b: 193 },
        { position: 0.25, r: 29, g: 80, b: 235 },
        { position: 0.3125, r: 5, g: 125, b: 170 },
        { position: 0.375, r: 48, g: 155, b: 80 },
        { position: 0.40625, r: 55, g: 167, b: 34 },
        { position: 0.4375, r: 82, g: 177, b: 8 },
        { position: 0.5625, r: 187, g: 210, b: 3 },
        { position: 0.625, r: 234, g: 223, b: 2 },
        { position: 0.6875, r: 251, g: 202, b: 12 },
        { position: 0.8125, r: 252, g: 134, b: 20 },
        { position: 0.9375, r: 243, g: 36, b: 13 },
        { position: 1, r: 215, g: 5, b: 13 },
    ],
    rainbow_bgyr_35_85_c72_n256: [
        { position: 0, r: 0, g: 52, b: 245 },
        { position: 0.125, r: 0, g: 115, b: 157 },
        { position: 0.1875, r: 49, g: 132, b: 118 },
        { position: 0.3125, r: 66, g: 165, b: 27 },
        { position: 0.375, r: 106, g: 175, b: 18 },
        { position: 0.625, r: 246, g: 204, b: 44 },
        { position: 0.75, r: 255, g: 163, b: 28 },
        { position: 1, r: 253, g: 48, b: 0 },
    ],
};

export function getGradients() {
    return [
        "color",
        "difference",
        "dirt",
        "cyclic_protanopic_deuteranopic_bwyk_16_96_c31_n256",
        "cyclic_protanopic_deuteranopic_wywb_55_96_c33_n256",
        "cyclic_tritanopic_cwrk_40_100_c20_n256",
        "cyclic_tritanopic_wrwc_70_100_c20_n256",
        "diverging_isoluminant_cjm_75_c23_n256",
        "diverging_isoluminant_cjo_70_c25_n256",
        "diverging_linear_bjr_30_55_c53_n256",
        "diverging_linear_bjy_30_90_c45_n256",
        "diverging_protanopic_deuteranopic_bwy_60_95_c32_n256",
        "diverging_rainbow_bgymr_45_85_c67_n256",
        "diverging_tritanopic_cwr_75_98_c20_n256",
        "diverging_bkr_55_10_c35_n256",
        "diverging_bky_60_10_c30_n256",
        "diverging_bwg_20_95_c41_n256",
        "diverging_bwr_20_95_c54_n256",
        "diverging_bwr_40_95_c42_n256",
        "diverging_bwr_55_98_c37_n256",
        "diverging_cwm_80_100_c22_n256",
        "diverging_gwr_55_95_c38_n256",
        "diverging_gwv_55_95_c39_n256",
        "isoluminant_cgo_70_c39_n256",
        "isoluminant_cgo_80_c38_n256",
        "isoluminant_cm_70_c39_n256",
        "linear_protanopic_deuteranopic_kbjyw_5_95_c25_n256",
        "linear_protanopic_deuteranopic_kbw_5_98_c40_n256",
        "linear_tritanopic_krjcw_5_95_c24_n256",
        "linear_tritanopic_krjcw_5_98_c46_n256",
        "linear_bgyw_20_98_c66_n256",
        "linear_blue_95_50_c20_n256",
        "linear_bmw_5_95_c86_n256",
        "linear_bmy_10_95_c71_n256",
        "linear_gow_60_85_c27_n256",
        "linear_gow_65_90_c35_n256",
        "linear_grey_0_100_c0_n256",
        "linear_grey_10_95_c0_n256",
        "linear_kbc_5_95_c73_n256",
        "linear_kbgyw_10_98_c63_n256",
        "linear_kgy_5_95_c69_n256",
        "linear_kryw_0_100_c71_n256",
        "linear_kry_0_97_c73_n256",
        "linear_ternary_blue_0_44_c57_n256",
        "linear_ternary_green_0_46_c42_n256",
        "linear_ternary_red_0_50_c52_n256",
        "linear_wcmr_100_45_c42_n256",
        "linear_worb_100_25_c53_n256",
        "linear_wyor_100_45_c55_n256",
        "rainbow_bgyrm_35_85_c69_n256",
        "rainbow_bgyr_10_90_c83_n256",
        "rainbow_bgyr_35_85_c72_n256",
    ];
}

export var defaultColors = [
    "#00D6FA",
    "#8C5E3F",
    "#FA6400",
    "#6DD400",
    "#B620E0",
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#4A90E2",
    "#30E3C2",
    "#B8E986",
    "#1A90E2",
    "#896792",
    "#50E3C2",
    "#A8E976",
    "#000000",
    "#4A4A4A",
    "#FFFFFF",
];

export const MAX_MESHSET_COUNT = 100;
